import React, { useState } from 'react';
import { Link2, Check, MessageSquare } from 'lucide-react';
import { toast } from 'sonner';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const btn = 'inline-flex items-center justify-center gap-2 h-11 px-5 rounded-full text-sm font-medium transition-colors';

export const shareUrlFor = (slug) => `${API_BASE}/api/listings/${slug}/share`;

export const CopyShareLink = ({ url }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success('Share link copied. Paste it in a text or post to show the photo card');
      setTimeout(() => setCopied(false), 2500);
    } catch {
      window.prompt('Copy this share link:', url);
    }
  };
  return (
    <button type="button" onClick={copy} className={`${btn} bg-[#C6A14A] text-[#050816] hover:bg-[#D4AF5A]`} data-testid="editor-copy-share-link">
      {copied ? <Check className="h-4 w-4" /> : <Link2 className="h-4 w-4" />} {copied ? 'Copied' : 'Copy share link'}
    </button>
  );
};

export const smsHref = (phone, street, url) => {
  const to = (phone || '').replace(/[^\d+]/g, '');
  const body = `Here's the property website for ${street || 'your listing'}: ${url}`;
  return `sms:${to}?&body=${encodeURIComponent(body)}`;
};

export const TextAgentButton = ({ phone, street, url }) => (
  <a href={smsHref(phone, street, url)} className={`${btn} border border-[#C6A14A]/50 text-[#C6A14A] hover:bg-[#C6A14A]/10`} data-testid="editor-text-agent">
    <MessageSquare className="h-4 w-4" /> Text to agent
  </a>
);

export const ShareCardPreview = ({ listing, address, facts }) => {
  const title = [address.street, address.city, address.state].filter(Boolean).join(', ') || 'Property';
  const v = `${listing.hero_photo_id || ''}${listing.updated_at || ''}`;
  return (
    <div className="max-w-md rounded-2xl overflow-hidden border border-white/10 bg-[#1c1f26]" data-testid="share-card-preview">
      <img src={`${API_BASE}/api/listings/${listing.slug}/hero.jpg?v=${encodeURIComponent(v)}`} alt={title}
        className="w-full aspect-[1.91/1] object-cover bg-black/40" data-testid="share-card-image" />
      <div className="px-4 py-3 space-y-0.5">
        <p className="text-[11px] uppercase tracking-wide text-white/40">rcstudios.net</p>
        <p className="text-white text-sm font-semibold leading-snug" data-testid="share-card-title">{title}</p>
        <p className="text-white/50 text-xs line-clamp-2">{facts ? `${facts}. ` : ''}Photos and details for {title}. Photos by RC Studios.</p>
      </div>
    </div>
  );
};
